import AddProductForm from 'components/products/AddProduct';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { fetchSingleProduct } from '../../../redux/slices/products';
import { useParams } from 'react-router-dom';
import CommonLayout from 'layouts/DashboardLayout';
import { Box } from '@mui/material';
import { getData } from 'utilities/common';
import { STILO } from 'utilities/constants';
import AddStiloProductForm from 'components/products/AddStiloProduct';

export default function AddProduct() {
  const dispatch = useDispatch();
  const { productId = '' } = useParams();
  const adminsMode = getData('adminsMode')
  const isStilo = JSON.parse(adminsMode) === STILO
  useEffect(() => {
    if (productId) {
      dispatch(fetchSingleProduct(productId));

    }
  }, [productId]);
  return (
    <CommonLayout>
      <Box p={{ xs: 2, sm: 3, lg: 4 }}>
        {
          isStilo ? <AddStiloProductForm />
            :
            <AddProductForm />

        }
      </Box>
    </CommonLayout>
  );
}